document.addEventListener( 'DOMContentLoaded', function () {
  // Returns the offset of a timezone in minutes at the given moment.
  function timezoneOffset( timeZone, date ) {
    var values = {};

    new Intl.DateTimeFormat( 'en-US', {
      timeZone: timeZone,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    } ).formatToParts( date ).forEach( function ( part ) {
      values[ part.type ] = part.value;
    } );

    return ( Date.UTC( values.year, values.month - 1, values.day, values.hour % 24, values.minute, values.second ) - date.getTime() ) / 60000;
  }

  document.querySelectorAll( '.content__expert-time[data-timezone]' ).forEach( function ( chip ) {
    var timeZone = chip.getAttribute( 'data-timezone' );
    var clock = chip.querySelector( '.content__expert-time-clock' );
    var arrow = chip.querySelector( '.content__expert-time-arrow' );
    var diff = chip.querySelector( '.content__expert-time-diff' );

    try {
      var now = new Date();

      clock.textContent = new Intl.DateTimeFormat( 'nl-NL', {
        timeZone: timeZone,
        hour: '2-digit',
        minute: '2-digit',
      } ).format( now );

      var hours = ( timezoneOffset( timeZone, now ) - timezoneOffset( 'Europe/Amsterdam', now ) ) / 60;

      if ( 0 === hours ) {
        arrow.remove();
        diff.remove();
      } else {
        diff.textContent = new Intl.NumberFormat( 'nl-NL' ).format( Math.abs( hours ) ) + ' uur ' + ( hours < 0 ? 'vroeger' : 'later' );
      }

      chip.hidden = false;
    } catch ( e ) {
      // Unknown timezone: leave the chip hidden.
    }
  } );

  document.querySelectorAll( '.content__share-button--copy' ).forEach( function ( button ) {
    button.addEventListener( 'click', function () {
      var url = button.getAttribute( 'data-url' );

      if ( navigator.clipboard ) {
        navigator.clipboard.writeText( url ).then( function () {
          button.classList.add( 'is-copied' );

          setTimeout( function () {
            button.classList.remove( 'is-copied' );
          }, 2000 );
        } );
      }
    } );
  } );
} );
